export enum AnnexedProposalStatuses {
  DRAFT = 'draft',
  SENT = 'sent',
  APPROVED = 'approved',
  DECLINED = 'declined',
  EVALUATING = 'evaluating'
}
